// removed by extract-text-webpack-plugin
module.exports = {"header":"header___2TFHK","actions":"actions___1Lo7V","actions__button":"actions__button___1LsmC","pagination":"pagination___2uMaR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Userrequest/UserrequestList.module.scss
// module id = 666
// module chunks = 0